/*
  SPDX-License-Identifier: SEE LICENSE IN EULA.md
  SPDX-FileCopyrightText: 2020-2026 CYBERTEC PostgreSQL International GmbH <office@cybertec.at>
*/
import { ComponentsOverrides, ComponentsProps, ComponentsVariants } from '@mui/material';

import { CIColors } from 'shared';

type MuiTooltipComponent = {
  defaultProps?: ComponentsProps['MuiTooltip'];
  styleOverrides?: ComponentsOverrides['MuiTooltip'];
  variants?: ComponentsVariants['MuiTooltip'];
};

export const TooltipComponent: MuiTooltipComponent = {
  styleOverrides: {
    tooltip: {
      border: '1px solid #EEEEEE',
      backgroundColor: '#ffffff',
      fontSize: '16px',
      lineHeight: '24px',
      padding: '5px 10px',
      fontWeight: 500,
      color: CIColors.Primary,
    },
    arrow: {
      color: '#ffffff',
      '&:before': {
        border: '1px solid #EEEEEE',
      },
    },
  },
};
